module.exports = __webpack_public_path__ + "img/bg1.34aec50b.png";